/* @flow */

import React from 'react';
import type { $Configuration } from '../../types/Configuration';
import type { $Dealer } from '../../types/Dealer';
import type { $Translation } from '../../types/Translation';
import WorkbenchIcon from '../WorkbenchIcon/WorkbenchIcon';
import WorkbenchIcons from '../WorkbenchIcon/WorkbenchIcons';
import { convertDealerDistance } from '../../utils/DealerUtils';

type $Props = {
  dealer: $Dealer,
  configuration: $Configuration,
  translations: Array<$Translation>,
  settings: Object,
  modifierClass?: string
};

const DealerDistance = (props: $Props) => {
  const distance = convertDealerDistance(props.dealer, props.configuration, props.settings, props.translations);
  return (
    <div className={"dl-m-act-distance" + (props.modifierClass ? ` ${props.modifierClass}` : '')}>
        <WorkbenchIcon icon={WorkbenchIcons.ICO_LOCATION} modifierClass="dl-m-act-distance__ico" />
        <span className="dl-m-act-distance__container">
          <span className="dl-m-act-distance__value">{distance}</span>
        </span>
        <WorkbenchIcon icon={WorkbenchIcons.ICO_DEALER_MARKER} modifierClass="dl-m-act-distance__ico" />
    </div>
  );
};

export default DealerDistance;
